/**
 * Маркеры «целевого» исхода диалога (удержание/успех) в строке `outcome`.
 * Исход, содержащий любой из маркеров, трактуется как целевой (положительный).
 */
const POSITIVE_OUTCOME_MARKERS = ['удерж', 'retain', 'kept', 'held', 'target', 'success'];

/**
 * Определяет, является ли исход диалога целевым (удержание) — для окраски бейджа.
 * Целевой исход красится как `primary`, прочий (отказ) — как `destructive`.
 */
export const isPositiveOutcome = (outcome: string): boolean => {
  const value = outcome.trim().toLowerCase();
  return POSITIVE_OUTCOME_MARKERS.some((marker) => value.includes(marker));
};
